import type ja from './ja';

const en = {
    footer: {
        guide: 'Guide',
        faq: 'FAQ',
        termsOfService: 'Terms',
    },
} satisfies typeof ja;

export default en;
